// Follow: keeps the selected train in view.

import type { LatLon } from './types.ts';

export interface PanMap {
  // True while the camera moves: an animation, or the user dragging,
  // zooming or pinching. (MapLibre's map.isMoving().)
  readonly isMoving: () => boolean;
  readonly panTo: (target: LatLon, options: { readonly animate: boolean; readonly duration: number }) => unknown;
}

export interface FollowerOptions {
  readonly reduceMotion?: boolean;
}

// Keeps target() (a { lat, lon } or null) in view. Call it every animation
// frame with the frame's timestamp. It pans at most every 400 ms and never
// while the camera is moving, so it can't interrupt a flight or a gesture.
export function follower(
  map: PanMap,
  target: () => LatLon | null,
  options: FollowerOptions = {},
): (ts: number) => void {
  let last = 0;
  return (ts) => {
    if (map.isMoving() || ts - last <= 400) return;
    const p = target();
    if (!p) return;
    last = ts;
    map.panTo(p, { animate: options.reduceMotion !== true, duration: 400 });
  };
}
